import { render, staticRenderFns } from "./inspectUnit.vue?vue&type=template&id=896156c2&scoped=true&"
import script from "./inspectUnit.vue?vue&type=script&lang=js&"
export * from "./inspectUnit.vue?vue&type=script&lang=js&"
import style0 from "./inspectUnit.vue?vue&type=style&index=0&id=896156c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896156c2",
  null
  
)

export default component.exports